(() => {
  const script = document.currentScript;
  const ready = fetch(script.dataset.rules).then(r => { if (!r.ok) throw new Error('Gift settings unavailable.'); return r.json(); });
  const root = window.Shopify?.routes?.root || '/';
  const request = async (path, body) => {
    const r = await fetch(root + path, body ? {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(body)} : {});
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || 'Unable to update complimentary gifts.');
    return data;
  };
  function expected(config, items) {
    const result = new Map();
    for (const item of items) {
      if (item.properties?._aura_gift) continue;
      for (const rule of config.rules) {
        if (!rule.triggers.includes(String(item.variant_id))) continue;
        for (const gift of rule.gifts) {
          const key = rule.offer + ':' + gift.id;
          const old = result.get(key);
          result.set(key, {id:gift.id,offer:rule.offer,quantity:(old?.quantity || 0) + gift.quantity * item.quantity});
        }
      }
    }
    return result;
  }
  let running;
  async function reconcile() {
    const config = await ready;
    let cart = await request('cart.js');
    const wanted = expected(config, cart.items);
    const updates = {}, existing = new Set();
    let changed = false;
    for (const item of cart.items) {
      if (!item.properties?._aura_gift) continue;
      const key = item.properties._aura_offer + ':' + item.variant_id;
      const quantity = existing.has(key) ? 0 : (wanted.get(key)?.quantity || 0);
      existing.add(key);
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    if (Object.keys(updates).length) { cart = await request('cart/update.js',{updates}); changed = true; }
    const additions = [...wanted.entries()].filter(([key]) => !existing.has(key)).map(([,g]) => ({id:g.id,quantity:g.quantity,properties:{_aura_gift:'true',_aura_offer:g.offer}}));
    if (additions.length) { await request('cart/add.js',{items:additions}); changed = true; }
    return changed;
  }
  const sync = () => running || (running = reconcile().finally(() => { running = null; }));
  window.AuraGifts = {sync, expected};
  function showError(message) {
    let box = document.querySelector('[data-aura-gift-error]');
    if (!box) { box = document.createElement('p'); box.dataset.auraGiftError=''; box.setAttribute('role','alert'); document.querySelector('.aura-cart-footer, [data-aura-buy]')?.prepend(box); }
    box.textContent = message;
  }
  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const config = await ready;
      for (const buy of document.querySelectorAll('[data-aura-buy]')) {
        const panel = document.createElement('quantity-gifts');
        panel.className = 'aura-quantity-gifts';
        buy.append(panel);
        const render = () => {
          const variant = buy.querySelector('[name=id]').value;
          const selected = config.rules.filter(r => r.triggers.includes(variant));
          panel.replaceChildren();
          panel.hidden = !selected.length;
          if (!selected.length) return;
          const heading = document.createElement('h3'); heading.textContent = 'Complimentary gifts with this monitor'; panel.append(heading);
          const list = document.createElement('ul');
          for (const rule of selected) for (const gift of rule.gifts) {
            const li = document.createElement('li');
            const details = config.gifts[gift.id];
            if (details.image) { const img = document.createElement('img'); img.src=details.image; img.alt=''; img.width=64; img.height=64; img.loading='lazy'; li.append(img); }
            const text = document.createElement('span'); text.textContent = gift.quantity + ' × ' + details.title;
            const price = document.createElement('strong'); price.textContent='FREE'; li.append(text,price); list.append(li);
          }
          panel.append(list);
          const note = document.createElement('p'); note.textContent = 'Added automatically with your monitor. Subject to gift availability.'; panel.append(note);
        };
        buy.addEventListener('change',render); render();
        buy.closest('[data-aura-product]')?.querySelectorAll('[is="product-bundle-details"]').forEach(x => x.remove());
      }
      const cartForm = document.querySelector('.aura-native form[action$="/cart"]');
      if (cartForm) {
        const buttons = [...cartForm.querySelectorAll('button')];
        buttons.forEach(b => b.disabled=true);
        try { if (await sync()) { location.reload(); return; } } catch (error) { showError(error.message); }
        buttons.forEach(b => b.disabled=false);
        cartForm.addEventListener('submit',async event => {
          event.preventDefault(); buttons.forEach(b => b.disabled=true);
          try {
            await request('cart/update.js',{updates:[...cartForm.querySelectorAll('[name="updates[]"]')].map(i => Number(i.value))});
            await sync();
            const checkedCart = await request('cart.js');
            if (checkedCart.items.some(item => item.properties?._aura_gift && item.final_line_price > 0)) throw new Error('A complimentary gift discount could not be applied. Please contact us before completing your order.');
            if (event.submitter?.name === 'checkout') location.assign(root+'checkout'); else location.reload();
          } catch (error) { showError(error.message); buttons.forEach(b => b.disabled=false); }
        });
      }
    } catch (error) { showError(error.message); }
  });
})();
